export default {
  getAgendaInfo: '/messagemanager/api/calendar/app/list', // 日程列表
  getMedicalGuideTable: '/messagemanager/api/hos_guide/group/{0}', // 就医指南分组及详情
  getMedicalGuideInfo: '/messagemanager/api/hos_guide/{0}', // 就医指南单条
  getTipCaptionInfo: '/messagemanager/api/hos_guide/note/{0}/{1}', // 须知信息
  getBulletinInfo: '/messagemanager/api/hos_plat_notice/mini/page', // 公告信息
  getServiceMessage: '/messagemanager/api/sys-msg/page', // 服务通知列表
  readServiceMessage: '/messagemanager/api/sys-msg/read/{0}', // 单条修改服务通知已读
  readEntireServiceMessage: '/messagemanager/api/sys-msg/batch-read', // 服务通知全部已读
  deleteServiceMessage: '/messagemanager/api/sys-msg/delete/{0}', // 单条删除服务通知
  getUserMessageInfo: '/messagemanager/api/user_switch/list', // 调取用户消息推送列表
  handleUserMessageInfo: '/messagemanager/api/user_switch/change' // 用户修改是否允许消息推送
};
